export const AppRoutes = {
  Auth: {
    AdminLogin: (): string => {
      return '/auth';
    },
    DeleteUserAccount: (): string => '/delete-user-account',
  },

  Dashboard: {
    Home: (): string => '/',
    CategoriesManagement: (): string => '/categories-management',
    InstagramContentModeration: (): string => '/instagram-content-moderation',
    UserManagement: (): string => '/user-management',
  },

  PrivacyPolicy: (): string => '/privacy-policy',

  NOT_FOUND: (): string => '/not-found',
} as const;
